import { useSelector, useDispatch } from 'react-redux';
import * as jobActions from 'actions/jobActions';
import * as clientDetailsActions from 'actions/clientDetailsActions';
import * as jobLocationActions from 'actions/jobLocationActions';
import JobDetailsEditPage from './JobDetailsEditPage';
import {
  getDefaultContactsByNoticeKey,
  getDefaultSendNoticeOfIntentionValue
} from 'selectors/formSelectors';
import { useParams,useNavigate } from 'react-router-dom';
import React from 'react';
import { bindActionCreators } from 'redux';
import { getJob } from '../../api/operationsApi';

const JobDetailsEditContainer = () => {
  const dispatch = useDispatch();
  const { id: jobId } = useParams();

  const currentJob = useSelector(state => state.currentJob);
  const clientDetails = useSelector(state => state.clientDetails);
  
  const isCreditAllowed = clientDetails ? clientDetails.isCreditAllowed : 'false';
  const navigate = useNavigate(); // Use the useNavigate hook
  //const state = useSelector((state) => state);
  //const sendNotice = getDefaultSendNoticeOfIntentionValue(state, { match: { params: { id: jobId } } });
  //const contactIds = getDefaultContactsByNoticeKey(state, currentJob.areaId, 'defaultForNotificationOfIntent');


  const sendNotice = useSelector(state => getDefaultSendNoticeOfIntentionValue(state, { match: { params: { id: jobId } } }));
  const contactIds = useSelector(state => getDefaultContactsByNoticeKey(state, currentJob?currentJob.areaId:null, 'defaultForNotificationOfIntent'));

  
  const jobDetails = currentJob && {
    ...currentJob,
    newNoticeOfIntendedTreatment: {
      sendNotice,
      contactIds,
    }
    /*newNoticeOfIntendedTreatment: { 
      sendNotice: getDefaultSendNoticeOfIntentionValue(currentJob, { match: { params: { id: jobId } } }),
      contactIds: getDefaultContactsByNoticeKey(currentJob, currentJob.areaId, 'defaultForNotificationOfIntent')
    }*/
  };
  
  const canEditJob = currentJob && currentJob.canEditJob;

  const actions =bindActionCreators( {
    ...jobActions,
    ...clientDetailsActions,
    ...jobLocationActions,
    ...getJob,
  },dispatch);

  return (
    <JobDetailsEditPage
      isCreditAllowed={isCreditAllowed}
      clientDetails={clientDetails}
      currentJob={jobDetails}
      canEditJob={canEditJob}
      jobId={jobId}
      actions={actions}
      navigate={navigate} // Pass navigate here
    />
  );
};

export default (JobDetailsEditContainer);
